import { Activity, memo } from 'react';

import { Button } from '@/components/UI/Button/Button';
import ErrorState from '@/components/UI/ErrorState/ErrorState';

import Sidepanel from './components/Sidepanel/Sidepanel';
import TableHeaders from './components/Table/TableHeaders';
import TableKnoop from './components/Table/TableKnoop';
import TableMaterieel from './components/Table/TableMaterieel';
import VoorraadbeheerTooltip from './components/VoorraadBeheer/VoorraadbeheerTooltip';
import usePlankTable from './hooks/usePlank';
import usePlankTableStore from './hooks/usePlankTableStore';

import styles from './PlankView.module.css';

const Tooltip = memo(VoorraadbeheerTooltip);
const SidepanelMemo = memo(Sidepanel);
const Headers = memo(TableHeaders);
const Materieel = memo(TableMaterieel);
const Knoop = memo(TableKnoop);
const PlankView = () => {
  const { isBlockingError, refetchCritical } = usePlankTable();
  const totalWidth = usePlankTableStore((state) => state.getTotalWidth());
  const tableView = usePlankTableStore((state) => state.tableView);

  if (isBlockingError) {
    return (
      <div className={styles.plankViewMainContainer}>
        <ErrorState>
          <Button variant='primary' onClick={() => refetchCritical()}>
            Opnieuw proberen
          </Button>
        </ErrorState>
      </div>
    );
  }

  return (
    <div className={styles.plankViewMainContainer}>
      <div className={styles.plankViewTableContainer}>
        <Tooltip />
        <div
          className={[styles.plankViewStyle, tableView === 'materieel' ? '' : styles.plankViewStyleKnoop].join(' ')}
          style={{ '--plank-view-width': `${totalWidth}px` } as React.CSSProperties}
        >
          <Headers>
            <Activity mode={tableView === 'materieel' ? 'visible' : 'hidden'}>
              <Materieel />
            </Activity>
            <Activity mode={tableView === 'knoop' ? 'visible' : 'hidden'}>
              <Knoop />
            </Activity>
          </Headers>
        </div>
      </div>
      <div className={styles.plankViewSidepanelContainer}>
        <SidepanelMemo />
      </div>
    </div>
  );
};
export default PlankView;
